<template lang="pug">
menu-item(:label=`$t('catalog')`)    
  menu-item(:label=`$t('list')`, v-model="module.showList", keybind="K")
  menu-separator
  menu-item(v-for="co in this.frameStore.cos", :key="Id(co)", :label="co.name")
    menu-item(:label=`$t('table')`, v-model="co.showTable")
    menu-item(:label=`$t('chart')`, v-model="co.showChart")
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { CatalogOverplotModule } from "@/modules/CatalogOverplotModule";
import { FrameStore } from "@/modules/base";

@Component
export default class extends Vue {
  @Prop({ required: true })
  module!: CatalogOverplotModule

  @Prop({ required: true })
  frameStore!: FrameStore<typeof CatalogOverplotModule>
}
</script>

<i18n>
en:
  catalog: Catalog
  list: List
  table: Table
  chart: Chart
ja:
  catalog: カタログ
  list: 一覧
  table: テーブル
  chart: チャート

</i18n>